module.exports = __webpack_public_path__ + "static/media/CarryOn_HandLaggage_Arrows_iOS13.e07180c7.usdz";